const checkIsFlexibleMoveIn = (accommodationDetails: any, availableRooms: any) => {
  const isFlexibleDuration = accommodationDetails?.duration === "flexible";
  const isOtherMoveIn = accommodationDetails?.inventory_id == accommodationDetails?.roomType;
  const tenancyId = accommodationDetails?.tenancyId || accommodationDetails?.inventory_id;

  return (
    isFlexibleDuration ||
    isOtherMoveIn ||
    Boolean(
      !availableRooms
        ?.find((r: any) => +r.id === +accommodationDetails?.roomType)
        ?.active_children?.find((t: any) => +t.id === +tenancyId)?.meta?.available_from_formatted,
    )
  );
};

export default checkIsFlexibleMoveIn;
